import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {RestoreUtils} from "../utils/RestoreUtils";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";


export class Idle implements FlowStatePresentation {
    private _flowStateController:FlowStateController;

    private _tl:gsap.core.Timeline | undefined;
    private _introTl:gsap.core.Timeline | undefined;
    private introHasRun:boolean = false;
    start(flowStateController: FlowStateController): void {
        this._tl = gsap.timeline();
        this._flowStateController = flowStateController;
        XwaysHoarder2Sound.SCATTER_WIN_ALREADY_PLAYED = false;

        if(!this.introHasRun && !RestoreUtils.hasRestored && !XwaysHoarder2.apiPlugin.isReplay) {
            this.introHasRun = true;
            this._tl.add(() => {
                XwaysHoarder2.waysCounter.transitionfade(0,0.001);
            });
            this._tl.add(() => {
                this._introTl = XwaysHoarder2.transitionPlayer.playGameIntro();
            });
            this._tl.add(() => {
                XwaysHoarder2.waysCounter.transitionfade(1, 1.5);
            }, 1.5);
        }

        flowStateController.setSkipCallback(() => this.skip(flowStateController));

    }

    private complete(flowStateController:FlowStateController) {
        this._flowStateController.finish();
        delete this._tl;
    }


    private skip(flowStateController:FlowStateController):void {
        if(this._tl) {
            this._tl.kill();
        }
        if(this._introTl) {
            this._introTl.progress(1);
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.START_GAME);
            XwaysHoarder2.waysCounter.show();
            XwaysHoarder2.waysCounter.transitionfade(1,0.0001);
        }
        this.complete(flowStateController);
    }
}